// extracted by mini-css-extract-plugin
module.exports = {"new-price":"NewPrice_new-price__2J2j8","current-price":"NewPrice_current-price__24p4M"};